import { useEffect, useRef } from 'react';
// routes
import { usePathname } from 'src/routes/hook';

// ----------------------------------------------------------------------

/**
 * Reports a GA4 page_view whenever the route changes.
 *
 * This site is a single page app: after the first load, navigation happens in the
 * browser and never reaches the server, so nothing else would report it. Without this
 * hook GA records only the landing page of every visit.
 *
 * GA4's "page changes based on browser history events" would also do this, but the two
 * together would double count. Leave that setting OFF in the GA4 property and let this
 * be the single source of page views.
 *
 * The tag itself lives in public/index.html and only loads on the production hostname,
 * so on staging and locally window.gtag is undefined and this quietly does nothing.
 */
export function usePageAnalytics() {
  const pathname = usePathname();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    // gtag('config') in index.html already reported the initial page
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    window.gtag('event', 'page_view', {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname]);
}
